import React, { useEffect, useRef, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/Logo/logo1.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setMobileDropdownOpen(false);
    }
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleMobileDropdown = () => {
    setMobileDropdownOpen(!mobileDropdownOpen);
  };

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    setDropdownOpen(false);
    setMobileDropdownOpen(false);
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="lg:flex-shrink-0 flex items-center">
              <img className="h-14 w-auto" src={logo} alt="Logo" />
              <span className="ml-2 text-sm lg:text-xl font-extrabold text-orange-400">
                Spectrum Nurturing Academy
              </span>
            </Link>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `font-medium ${
                  isActive
                    ? "text-orange-500 underline underline-offset-4"
                    : "hover:text-orange-500"
                }`
              }
            >
              <span className="text-xl font-bold">H</span>OME
            </NavLink>

            <div className="relative" ref={dropdownRef}>
              <button
                onClick={toggleDropdown}
                className="hover:text-orange-500 font-medium flex items-center focus:outline-none"
              >
                <span className="first-letter:font-bold first-letter:text-xl">
                  PROGRAMS & SERVICES
                </span>

                <svg
                  className="w-4 h-4 ml-1"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {dropdownOpen && (
                <div className="absolute left-0 mt-2 w-64 bg-white border rounded-lg shadow-lg py-2 z-50">
                  <NavLink
                    to="/courses"
                    className={({ isActive }) =>
                      `block px-6 py-2 ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:bg-orange-50"
                      }`
                    }
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="text-xl font-bold">P</span>RE-SCHOOL
                    TRANSITION SUPPORT
                  </NavLink>

                  <NavLink
                    to="/speech-therapy"
                    className={({ isActive }) =>
                      `block px-6 py-2 ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:bg-orange-50"
                      }`
                    }
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="text-xl font-bold">S</span>PEECH & LANGUAGE
                    THERAPY
                  </NavLink>

                  <NavLink
                    to="/applied-behaviour"
                    className={({ isActive }) =>
                      `block px-6 py-2 ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:bg-orange-50"
                      }`
                    }
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="text-xl font-bold">A</span>PPLIED BEHAVIOR
                    ANALYSIS (ABA)
                  </NavLink>

                  <NavLink
                    to="/occupational-therapy"
                    className={({ isActive }) =>
                      `block px-6 py-2 ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:bg-orange-50"
                      }`
                    }
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="text-xl font-bold">O</span>CCUPATIONAL
                    THERAPY (OT)
                  </NavLink>

                  <NavLink
                    to="/parent-training"
                    className={({ isActive }) =>
                      `block px-6 py-2 ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:bg-orange-50"
                      }`
                    }
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="text-xl font-bold">P</span>ARENT TRAINING
                    AND EMPOWERMENT
                  </NavLink>

                  <NavLink
                    to="/developmental-behavior-therapy"
                    className={({ isActive }) =>
                      `block px-6 py-2 ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:bg-orange-50"
                      }`
                    }
                    onClick={() => setDropdownOpen(false)}
                  >
                    <span className="text-xl font-bold">S</span>OCIAL SKILLS
                    DEVELOPMENT PROGRAMS
                  </NavLink>
                </div>
              )}
            </div>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `font-medium ${
                  isActive
                    ? "text-orange-500 underline underline-offset-4"
                    : "hover:text-orange-500"
                }`
              }
            >
              <span className="text-xl font-bold">A</span>BOUT
            </NavLink>

            <NavLink
              to="/contact"
              className="bg-orange-400 text-white px-6 py-2 rounded-full shadow hover:bg-orange-500 transition whitespace-nowrap"
            >
              <span className="text-xl font-bold">C</span>ONTACT US
            </NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-gray-500 hover:text-gray-600 focus:outline-none"
            >
              {isMenuOpen ? (
                <FaTimes className="h-6 w-6" />
              ) : (
                <FaBars className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `block px-3 py-2 rounded-md text-base font-medium ${
                  isActive
                    ? "text-orange-500 underline underline-offset-4"
                    : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                }`
              }
              onClick={handleMenuClick}
            >
              <span className="text-xl font-bold">H</span>OME
            </NavLink>
            <div className="relative">
              <button
                onClick={toggleMobileDropdown}
                className="w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-orange-500 hover:bg-orange-50 flex items-center justify-between"
              >
                <span>Programs & Services</span>
                <svg
                  className={`w-4 h-4 ml-1 transform transition-transform ${
                    mobileDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {mobileDropdownOpen && (
                <div className="pl-4 space-y-1 mt-1">
                  <NavLink
                    to="/courses"
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                      }`
                    }
                    onClick={handleMenuClick}
                  >
                    <span className="text-xl font-bold">P</span>RE-SCHOOL
                    TRANSITION SUPPORT
                  </NavLink>

                  <NavLink
                    to="/speech-therapy"
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                      }`
                    }
                    onClick={handleMenuClick}
                  >
                    <span className="text-xl font-bold">S</span>PEECH & LANGUAGE
                    THERAPY
                  </NavLink>

                  <NavLink
                    to="/applied-behaviour"
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                      }`
                    }
                    onClick={handleMenuClick}
                  >
                    <span className="text-xl font-bold">A</span>PPLIED BEHAVIOR
                    ANALYSIS (ABA)
                  </NavLink>

                  <NavLink
                    to="/occupational-therapy"
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                      }`
                    }
                    onClick={handleMenuClick}
                  >
                    <span className="text-xl font-bold">O</span>CCUPATIONAL
                    THERAPY (OT)
                  </NavLink>

                  <NavLink
                    to="/parent-training"
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                      }`
                    }
                    onClick={handleMenuClick}
                  >
                    <span className="text-xl font-bold">O</span>ARENT TRAINING
                    AND EMPOWERMENT
                  </NavLink>

                  <NavLink
                    to="/developmental-behavior-therapy"
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-orange-500 underline underline-offset-4"
                          : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                      }`
                    }
                    onClick={handleMenuClick}
                  >
                    <span className="text-xl font-bold">S</span>OCIAL SKILLS
                    DEVELOPMENT PROGRAMS
                  </NavLink>
                </div>
              )}
            </div>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `block px-3 py-2 rounded-md text-base font-medium ${
                  isActive
                    ? "text-orange-500 underline underline-offset-4"
                    : "text-gray-700 hover:text-orange-500 hover:bg-orange-50"
                }`
              }
              onClick={handleMenuClick}
            >
              <span className="text-xl font-bold">A</span>BOUT
            </NavLink>

            <Link
              to="/contact"
              className="inline-block px-3 py-2 rounded-md text-base font-medium bg-orange-400 text-white hover:bg-orange-500"
              onClick={handleMenuClick}
            >
              <span className="text-xl font-bold ">C</span>ONTACT US
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
